module.exports = __webpack_public_path__ + "static/media/cancel.575228b4.svg";